module.exports = __webpack_public_path__ + "media/images/auditoria-38fcf5ee8f65f9bc863f84e8d950c188.png";